import { render } from "./AssesstInvoice.vue?vue&type=template&id=31fd5c2c&scoped=true"
import script from "./AssesstInvoice.vue?vue&type=script&lang=js"
export * from "./AssesstInvoice.vue?vue&type=script&lang=js"

import "./AssesstInvoice.vue?vue&type=style&index=0&id=31fd5c2c&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fd5c2c"]])

export default __exports__